import html5Icon from "@iconify/icons-logos/html-5"
import css3Icon from "@iconify/icons-logos/css-3"
import javascriptIcon from "@iconify/icons-logos/javascript"
import jqueryIcon from "@iconify/icons-logos/jquery"
import reactIcon from "@iconify/icons-logos/react"
import gatsbyIcon from "@iconify/icons-logos/gatsby"
import nodejsIcon from "@iconify/icons-logos/nodejs"
import expressIcon from "@iconify/icons-logos/express"
import pythonIcon from "@iconify/icons-logos/python"
import elasticsearchIcon from "@iconify/icons-logos/elasticsearch"
import mongodbIcon from "@iconify/icons-logos/mongodb"
import redisIcon from "@iconify/icons-logos/redis"
import dockerIcon from "@iconify/icons-logos/docker"
import kubernetesIcon from "@iconify/icons-logos/kubernetes"
import vagrantIcon from "@iconify/icons-logos/vagrant"
import logstashIcon from "@iconify/icons-logos/logstash"
import kibanaIcon from "@iconify/icons-logos/kibana"
import beatsIcon from "@iconify/icons-logos/beats"
import kafkaIcon from "@iconify/icons-logos/kafka"
import prometheusIcon from "@iconify/icons-logos/prometheus"
import grafanaIcon from "@iconify/icons-logos/grafana"
import ansibleIcon from "@iconify/icons-logos/ansible"
import gitIcon from "@iconify/icons-logos/git"
import awsIcon from "@iconify/icons-logos/aws"

export default {
  html5Icon,
  css3Icon,
  javascriptIcon,
  jqueryIcon,
  reactIcon,
  gatsbyIcon,
  nodejsIcon,
  expressIcon,
  pythonIcon,
  elasticsearchIcon,
  mongodbIcon,
  redisIcon,
  dockerIcon,
  kubernetesIcon,
  vagrantIcon,
  logstashIcon,
  kibanaIcon,
  beatsIcon,
  kafkaIcon,
  prometheusIcon,
  grafanaIcon,
  ansibleIcon,
  gitIcon,
  awsIcon,
}
